<script setup lang="ts">
import { categoryOrder, SectionApplianceIcon, SectionApplianceText } from "@voltalis/ui-kit/components";

import { useTypedIntl } from "@/locales/typed-intl";

const { t, k } = useTypedIntl();
</script>

<template>
  <div class="flex justify-between items-center">
    <div class="flex gap-4 items-center">
      <section class="legend-item">
        <div class="w-[28px] h-[18px] default-program rounded" />
        <small>{{ t(k.control.piloting.planning.defaultProgram) }}</small>
      </section>

      <section class="legend-item">
        <div class="w-[28px] h-[1px] bg-red-600" />
        <small>{{ t(k.global.misc.today) }}</small>
      </section>
    </div>
    <div class="flex gap-4 items-center">
      <section
        v-for="category in categoryOrder"
        :key="category"
        class="legend-item"
      >
        <SectionApplianceIcon :sectionApplianceCategory="category" />
        <SectionApplianceText :applianceCategory="category" />
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.legend-item {
  @apply flex gap-2 items-center;

  * {
    @apply text-xs;
  }
}
</style>
